export const VIEW_BY = {
  CHART: {
    label: 'industryOverview.macroeconomics.CHART',
    value: 1,
    isI18n: true,
  },
  TABLE: {
    label: 'industryOverview.macroeconomics.TABLE',
    value: 2,
    isI18n: true,
  },
}

export const MACROECONOMICS_TAB = {
  GDP: {
    label: 'GDP',
    key: 1,
    value: 'RealGDP',
  },
  FDI: {
    label: 'FDI',
    key: 2,
    value: 'FDI',
  },
  IMPORT_EXPORT: {
    label: 'industryOverview.macroeconomics.IMPORT_EXPORT',
    key: 3,
    value: 'ImportExport',
  },
}

export const GDP_TAB = {
  REAL_GDP: {
    label: 'industryOverview.macroeconomics.REAL_GDP',
    key: 'REAL_GDP',
  },
  NOMINAL_GDP: {
    label: 'industryOverview.macroeconomics.NOMINAL_GDP',
    key: 'NOMINAL_GDP',
  },
}

export const IMPORT_EXPORT_TAB = {
  GROWTH_RATE_PERCENT: {
    label: 'industryOverview.macroeconomics.GROWTH_RATE_PERCENT',
    key: 1,
  },
  VALUE: {
    label: 'industryOverview.macroeconomics.VALUE',
    key: 2,
  },
}

export const SORT_BY = {
  IMPORT_DESCENDING: {
    label: 'industryOverview.macroeconomics.IMPORT_DESCENDING',
    isI18n: true,
    value: 'IMPORT_DESCENDING',
  },
  IMPORT_ASCENDING: {
    label: 'industryOverview.macroeconomics.IMPORT_ASCENDING',
    isI18n: true,
    value: 'IMPORT_ASCENDING',
  },
  'A->Z': { label: 'A->Z', isI18n: true, value: 'A->Z' },
  'Z->A': { label: 'Z->A', isI18n: true, value: 'Z->A' },
  EXPORT_ASCENDING: {
    label: 'industryOverview.macroeconomics.EXPORT_ASCENDING',
    isI18n: true,
    value: 'EXPORT_ASCENDING',
  },
  EXPORT_DESCENDING: {
    label: 'industryOverview.macroeconomics.EXPORT_DESCENDING',
    isI18n: true,
    value: 'EXPORT_DESCENDING',
  },
  BALANCE_TRADE_ASCENDING: {
    label: 'industryOverview.macroeconomics.BALANCE_TRADE_ASCENDING',
    isI18n: true,
    value: 'BALANCE_TRADE_ASCENDING',
  },
  BALANCE_TRADE_DESCENDING: {
    label: 'industryOverview.macroeconomics.BALANCE_TRADE_DESCENDING',
    isI18n: true,
    value: 'BALANCE_TRADE_DESCENDING',
  },
}
